// Angular
import { Injectable } from '@angular/core';
// RxJS
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Services
// State
import { AppState } from '../../../core/reducers';
import {
  ClearErrors,
  MeetingActionTypes,
  MeetingsActionToggleLoading,
  MeetingsPageCancelled,
  MeetingsPageLoaded,
  MeetingsPageRequested,
  MeetingsPageToggleLoading,
  ThrowError,
} from '../_actions/meeting.actions';
import { Router } from '@angular/router';
import { MeetingService } from '../_services/meeting.service';

@Injectable()
export class MeetingEffects {
  showPageLoadingDistpatcher = new MeetingsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new MeetingsPageToggleLoading({ isLoading: false });

  showActionLoadingDistpatcher = new MeetingsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new MeetingsActionToggleLoading({ isLoading: false });

  @Effect()
  loadMeetingsPage$ = this.actions$.pipe(
    ofType<MeetingsPageRequested>(MeetingActionTypes.MeetingsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.meeting.findMeetings(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin(requestToServer, lastQuery).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new MeetingsPageCancelled();
            } else {
              this.store.dispatch(new ThrowError({ error: response[0].error }));
              return new MeetingsPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearErrors());
            return new MeetingsPageLoaded({
              meetings: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private meeting: MeetingService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
